import { useEffect, useState } from 'react';
import useScrollPosition from "../../../common/hooks/useScrollPosition";

const useCollapsedBanner = (height, scrollOffsetTop) => {
    const [collapseBanner, setCollapseBanner] = useState(false);
    const [minimizeBanner, setMinimizeBanner] = useState(false);

    let { scrollYPosition, scrollYDirection } = useScrollPosition(10);
    const topOffsetHeight = scrollOffsetTop + height; 

    useEffect(() => {
        if (scrollYPosition > topOffsetHeight) {
            if (!collapseBanner) {
                setCollapseBanner(true);
            }
        }
        else {
            if (collapseBanner) {
                setCollapseBanner(false);
            }
        }
        if (scrollYDirection === 'up') {
            if ((scrollYPosition < (topOffsetHeight + 80)) && (scrollYPosition > topOffsetHeight)) {
                if (!minimizeBanner) {
                    setMinimizeBanner(true);
                }
            } else {
                if (minimizeBanner) {
                    setMinimizeBanner(false);
                }
            }
        } else {
            if (minimizeBanner) {
                setMinimizeBanner(false);
            }
        }
    }, [scrollYPosition]);

    return { collapseBanner, minimizeBanner };
}

export default useCollapsedBanner;